/* eslint react/prop-types: 0 */
import React from 'react';
import DateCell from './components/DateCell';
import CourseHeader from './components/CourseHeader';
import CourseCell from './components/CourseCell';
import HorseHeader from './components/HorseHeader';
import HorseCell from './components/HorseCell';
import PosCell from './components/PosCell';
import ProfileLink from '../../shared/links/ProfileLink';
import { sortByDate } from '../../utils/date';
import { zeroToDash } from '../../utils/number';

export const posSortFn = (a, b) => {
    const outcomeCodeA = a.raceOutcomeCode;
    const outcomeCodeB = b.raceOutcomeCode;

    if (isNaN(outcomeCodeA) && isNaN(outcomeCodeB)) {
        return sortByDate('raceDatetime')(a, b);
    }
    if (isNaN(outcomeCodeA)) {
        return 1;
    }
    if (isNaN(outcomeCodeB)) {
        return -1;
    }
    if (outcomeCodeA !== outcomeCodeB) {
        return outcomeCodeA - outcomeCodeB;
    }

    return sortByDate('raceDatetime')(a, b);
};

const columns = (profileType) => {
    const staff = profileType === 'trainer' ? 'jockey' : 'trainer';

    return [
        {
            key: 'raceDatetime',
            header: 'date',
            cell: DateCell,
            sortFn: sortByDate('raceDatetime'),
        },
        {
            key: 'courseRpAbbrev3',
            header: CourseHeader,
            cell: CourseCell,
            sortFn: 'alphabetic',
        },
        {
            key: 'raceOutcomeCode',
            header: 'pos.',
            cell: PosCell,
            sortFn: posSortFn,
        },
        {
            key: 'horseStyleName',
            header: () => <HorseHeader isJockey={profileType === 'jockey'} />,
            cell: props => <HorseCell {...props} profileType={profileType} />,
            sortFn: 'alphabetic',
        },
        {
            key: 'oddsDesc',
            header: 'sp',
            sortFn: ({ oddsValue: a }, { oddsValue: b }) => (a - b),
        },
        {
            key: `${staff}ShortName`,
            header: staff,
            cell: (rowData) => {
                const StaffLink = ProfileLink[staff];
                return (
                    <span>
                        <StaffLink {...rowData} />
                        {!!rowData.weightAllowanceLbs && staff === 'jockey' && (
                            <sup className="mp-form__jockeyAllowance">
                                {rowData.weightAllowanceLbs}
                            </sup>
                        )}
                    </span>
                );
            },
            sortFn: 'byLastName',
        },
        {
            key: 'rpPostmark',
            header: 'rpr',
            cell: zeroToDash('rpPostmark'),
        },
        {
            key: 'rpPostmarkDifference',
            header: 'diff',
        },
    ];
};

export default columns;



// WEBPACK FOOTER //
// ./src/js/human/form/columns.jsx